import React from 'react';
import PageHeader from './components/PageHeader';
import { useNavigate } from 'react-router-dom';

function SettingsLanding() {
  const navigate = useNavigate();

  const navItems = [
    { path: '/settings/company-profile', label: 'Company Profile', icon: '🏢', description: 'Company details and branding' },
    { path: '/settings/users-and-permissions', label: 'Users & Permissions', icon: '👥', description: 'Manage users, roles, and access control' },
    { path: '/settings/operations-files', label: 'Operations Setup', icon: '🔧', description: 'Parts, categories, and operational settings' },
    { path: '/settings/finance-setup', label: 'Finance Setup', icon: '💰', description: 'PPM, nominal codes, CIS, and financial config' },
    { path: '/settings/number-formats', label: 'Number Formats Setup', icon: '🔢', description: 'Document numbering configuration' },
    { path: '/settings/document-design', label: 'Document Design', icon: 'DD', description: 'Company colours and document design defaults' },
    { path: '/settings/data', label: 'Data Setup', icon: '📊', description: 'Import and export data' },
    { path: '/settings/ai-config', label: 'AI Configuration', icon: '🤖', description: 'Configure AI quote generation' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader
        title="Settings"
        subtitle="System Configuration & Preferences"
        backTo="/admin"
        backLabel="Administration"
        sticky
      />

      <main className="max-w-6xl mx-auto px-6 py-8">
        <div className="bg-gray-300 rounded-lg shadow p-6 mx-auto" style={{ width: 'fit-content', maxWidth: '1200px' }}>
          <h2 className="text-xl font-semibold text-gray-800 mb-6">Settings Categories</h2>
          <div className="grid grid-cols-4 gap-4 justify-items-center">
            {navItems.map((item) => (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className="flex flex-col items-center p-6 bg-white rounded-lg w-full max-w-xs border-2 border-black hover:border-blue-500 hover:shadow-lg transition-all group"
              >
                <span className="text-5xl mb-3 group-hover:scale-110 transition-transform">{item.icon}</span>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">{item.label}</h3>
                <p className="text-xs text-gray-500 text-center">{item.description}</p>
              </button>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}

export default SettingsLanding;
